import React from 'react';
import { Card, CardContent } from './ui/card';
import { ChevronRight } from 'lucide-react';
import { mockData } from '../mock';

const ProcessSection = () => {
  const steps = mockData.process.steps;

  return (
    <section id="process" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 見出し */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-6xl font-black text-gray-900 mb-6 font-din tracking-tight">
            ご利用は<span className="text-transparent bg-gradient-to-r from-blue-600 to-green-500 bg-clip-text py-1 px-1">かんたん</span><span class="font-noto-heading">3</span>ステップ。<br />
            すぐに<span className="text-blue-600 font-extrabold">実績イメージ</span>をご確認いただけます。
          </h2>
        </div>

        {/* タイムライン矢印（数日） */}
        <div className="relative mb-5 flex items-center justify-between">
          {/* 矢印付きライン */}
          <div className="relative w-full h-2 bg-sky-500 rounded-full">
            {/* 左矢印 */}
            <div className="absolute -left-2 top-1/2 -translate-y-1/2">
              <div
                className="w-0 h-1 border-t-[12px] border-b-[8px] border-r-[15px] border-transparent border-r-sky-500"
              />
            </div>

            {/* 右矢印 */}
            <div className="absolute -right-2 top-1/2 -translate-y-1/2">
              <div
                className="w-0 h-0 border-t-[12px] border-b-[8px] border-l-[15px] border-transparent border-l-sky-500"
              />
            </div>

            {/* テキスト */}
            <div className="mt-3 absolute inset-0 -translate-y-7 flex items-center justify-center">
              {/* <span className="text-sky-700 font-extrabold tracking-wide"> */}
              <span className="text-sky-700 font-black tracking-wide text-2xl sm:text-3xl lg:text-3xl">
                5~10営業日
              </span>
            </div>
          </div>
        </div>

        {/* 工程カード */}
        <div className="rounded-2xl bg-white/70 backdrop-blur-sm shadow-[0_6px_30px_rgba(15,23,42,0.06)] p-6 lg:p-8">
          <div className="grid gap-6 lg:grid-cols-3">
            {steps.map((step, i) => (
              <div key={step.title} className="relative">
                <Card className="h-full border-0 bg-gradient-to-br from-blue-50 via-white to-green-50 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 hover:rotate-1 group">
                  <CardContent className="p-6 relative overflow-hidden">
                    <div className="absolute -top-5 -right-5 w-20 h-20 bg-gradient-to-br from-blue-200/30 to-green-200/30 rounded-full"></div>
                    
                    {/* Step番号アイコン */}
                    <div className="mb-4 flex justify-center">
                      <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-green-500 rounded-2xl flex items-center justify-center text-2xl font-black text-white shadow-lg group-hover:scale-110 group-hover:rotate-12 transition-all duration-300 relative z-10 number-font-bold">
                        {String(i + 1).padStart(2, '0')}
                      </div>
                    </div>
                    
                    {/* タイトル */}
                    <h3 className="text-2xl font-black text-gray-900 mb-4 font-din tracking-tight text-center relative z-10">
                      {step.title}
                    </h3>

                    {/* サムネイル（任意） */}
                    <div className="mb-4 bg-gray-100 rounded-2xl overflow-hidden shadow-lg relative z-10">
                      {step.thumb ? (
                        <img
                          src={step.thumb}
                          alt={step.title}
                          className="w-full h-[230px] object-contain object-center bg-white"
                          loading="lazy"
                          decoding="async"
                        />
                      ) : (
                        <div className="w-full h-[200px] bg-gradient-to-br from-blue-100 via-white to-green-100" />
                      )}
                    </div>

                    {/* 説明 */}
                    <p className="text-gray-700 leading-relaxed text-base font-body relative z-10">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>

                {/* 矢印（中〜大画面で表示、少し右にずらし気味） */}
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-7 -translate-y-1/2 text-sky-400">
                    <ChevronRight className="w-8 h-8" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ProcessSection;



// import React from 'react';
// import { Card, CardContent } from './ui/card';
// import { ArrowRight } from 'lucide-react';
// import { mockData } from '../mock';

// const ProcessSection = () => {
//   return (
//     <section id="process" className="py-20 bg-gray-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-16">
//           <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
//             {mockData.process.title}
//           </h2>
//         </div>

//         <div className="relative">
//           <div className="grid lg:grid-cols-3 gap-8">
//             {mockData.process.steps.map((step, index) => (
//               <div key={index} className="relative">
//                 <Card className="bg-white border-0 shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
//                   <CardContent className="p-8 text-center">
//                     <div className="mb-6">
//                       <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
//                         <span className="text-2xl font-bold text-white">{step.number}</span>
//                       </div>
//                       <h3 className="text-xl font-bold text-gray-900">
//                         {step.title}
//                       </h3>
//                     </div>
                    
//                     <p className="text-gray-600 leading-relaxed">
//                       {step.description}
//                     </p>
//                   </CardContent>
//                 </Card>

//                 {/* Arrow connector */}
//                 {index < mockData.process.steps.length - 1 && (
//                   <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
//                     <ArrowRight className="w-8 h-8 text-blue-400" />
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Sample images gallery */}
//         <div className="mt-20">
//           <div className="text-center mb-12">
//             <h3 className="text-2xl font-bold text-gray-900 mb-4">
//               制作実績ギャラリー
//             </h3>
//             <p className="text-gray-600">
//               高品質な3Dモックアップの制作事例をご覧ください
//             </p>
//           </div>
          
//           <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
//             {mockData.gallery.map((image, index) => (
//               <div key={index} className="group cursor-pointer">
//                 <div className="relative overflow-hidden rounded-xl shadow-lg group-hover:shadow-xl transition-shadow">
//                   <img 
//                     src={image}
//                     alt={`制作事例 ${index + 1}`}
//                     className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
//                   />
//                   <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
//                     <span className="text-white font-semibold">詳細を見る</span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ProcessSection;